import { Homepage, Qrcode } from '@/typings/types';
import PageFooter from '@/common/pageFooter';
import Header from '@/components/qrcode/header';
import Buches from '@/components/qrcode/buches';
import Pains from '@/components/qrcode/pains';
import SlideUp from '@/common/utils/slideUp';
import { TextRenderer } from '@/common/utils/textRenderer';

type QrCodeWrapperProps = {
  homepage: Homepage;
  qrcode: Qrcode;
};

const QrCodeWrapper = ({ homepage, qrcode }: QrCodeWrapperProps) => {
  return (
    <main>
      <Header header={qrcode.header} />
      <section
        className={
          'text-chocolate w-11/12 lg:w-auto mx-auto lg:max-w-6xl mt-28 grid grid-cols-1 lg:grid-cols-2'
        }
      >
        <Buches buches={qrcode.buches} />
        <Pains
          pains={qrcode.pains}
          brioches={qrcode.brioches}
          painepices={qrcode.painepices}
          ballotins={qrcode.ballotins}
        />
      </section>
      <section
        className={
          'mt-10 w-full bg-qrcode-background bg-repeat py-32 flex items-center justify-center'
        }
      >
        <div
          className={
            'flex flex-col w-11/12 lg:w-8/12 mx-auto text-white bg-chocolate lg:grid lg:grid-cols-5 lg:gap-0 lg:py-5'
          }
        >
          {qrcode?.holidayOrderDeadlines && (
            <div
              className={
                'px-5 lg:px-0 flex py-10 flex-col w-full justify-center text-white text-center bg-caramel col-span-2 lg:ml-5'
              }
            >
              <SlideUp yOffset={-10} className={'text-white lg:w-[45%] mx-auto'}>
                <TextRenderer color={'white'} text={qrcode?.holidayOrderDeadlines} />
              </SlideUp>
            </div>
          )}
          {qrcode?.pickupAndStoreHours && (
            <div
              className={
                'self-center mx-auto flex flex-col w-10/12 text-white lg:w-[60%] col-span-3 py-10 lg:py-2'
              }
            >
              <SlideUp yOffset={-10} className={'text-white'}>
                <TextRenderer color={'white'} text={qrcode?.pickupAndStoreHours} />
              </SlideUp>
            </div>
          )}
        </div>
      </section>
      <PageFooter homepage={homepage} />
    </main>
  );
};

export default QrCodeWrapper;
